// libs
import styled from "styled-components";
import { colors } from "src/theme/colors";

export const RatingWrapper = styled.div`
  flex-shrink: 0;

  .rating {
    display: flex !important;
    flex-wrap: nowrap;
  }
`;

export const WarningMessage = styled.div`
  color: ${colors.redDark};
  font-size: 16px;
  margin-top: 8px;
`;
